import { render, staticRenderFns } from "./results-list.vue?vue&type=template&id=e86d25aa&"
import script from "./results-list.vue?vue&type=script&lang=js&"
export * from "./results-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports